<template>
  <div id="slide-show-editor">
    <CRow>
      <CCol xs="12" md="12" lg="12">
        <CCard style="border-radius: unset!important;">
          <CCardHeader
              style="border-radius: unset!important;position: unset!important;background: white!important;border-bottom: unset!important;"
              color="light"
              class="d-inline-flex justify-content-between align-items-center">
            <strong style="font-size: 18px;padding: 8px 0px;width: 100%;border-bottom: 1px solid #d8dbe0;">
              {{ getTitleHeader }}
            </strong>
          </CCardHeader>

          <CCardBody style="padding: unset!important; min-height: 70vh;">
            <template v-if="action === actionEditor.LAYOUT_SETTING">
              <div class="content-fade-in">
                <CCol xs="12" md="12" lg="12">
                  <BaseInput :options="titleInput.options"
                             :data="titleInput.data" class="input-wrapper"/>
                </CCol>
                <!--                <CCol xs="12" md="12" lg="12">-->
                <!--                  <BaseSelect :options="ratioSelect.options" :data="ratioSelect.data"-->
                <!--                              ref="ratioSelect"></BaseSelect>-->
                <!--                </CCol>-->
                <hr class="mt-4"/>

                <div class="group-layer-setting">
                  <div class="card-header d-inline-flex justify-content-between align-items-center bg-light title">
                    Bố cục giao diện
                  </div>
                  <CCol xs="12" md="12" lg="12">
                    <template v-if="items != null && items.length > 0">
                      <draggable :list="items" class="layers-wrapper" ghost-class="ghost"
                                 group="people"
                                 :move="checkMoveLayer"
                                 @start="drag=true"
                                 @end="drag=false">
                        <ul v-for="(element) in items">
                          <li class="layout_layer">
                            <span class="description" style="width: 85%;" @click.self="activeLayer(element.id)"
                                  :key="element.id" v-c-tooltip.hover="{
                              content: getTitleLayer(element),
                              placement: 'left',
                              delay: 1,
                            }">
                              {{ getTitleLayer(element) }}
                             </span>
                            <div class="text-right" @click="removeLayer(element.id)">
                              <i class="fa fa-trash" v-c-tooltip.hover="'Xóa'"></i>
                            </div>
                          </li>
                        </ul>
                      </draggable>
                    </template>
                    <template v-else>
                      <span class="no-layers-content-message" :class="isValidSubmit ? 'valid-error' : ''">Chưa có nội dung nào!</span>
                    </template>
                  </CCol>
                </div>
              </div>
            </template>

            <template v-else-if="action === actionEditor.ADD_LAYER">
              <div class="fadeInUp fade animated">
                <CRow style="margin: unset;padding: 15px;">
                  <template v-for="itemChoose of itemsLayerChoose">
                    <CCol :key="itemChoose.id" xs="12" md="12" lg="12" xl="6" class="layout-insert-item-column"
                          @click="chooseLayer(itemChoose)">
                      <div class="layout-insert-item-type">
                        <i class="fa" :class="itemChoose.icon"></i>
                      </div>
                      <span class="layout-insert-item-label"> {{ itemChoose.title }} </span>
                    </CCol>
                  </template>
                </CRow>

              </div>
            </template>

            <template v-else-if="action === actionEditor.EDITOR_LAYER">
              <SlideShowFormEditor :type="items[itemSelected].extractData.typeLayer" :item="items[itemSelected]"/>
            </template>

          </CCardBody>

          <CCardFooter style="text-align: center" class="mt-2">
            <CButton
                color="primary"
                class="btn-action-primary mr-2" @click="submitSaveSlideShow()">
              <i class="fa fa-save"></i> Lưu lại
            </CButton>
            <CButton
                color="secondary"
                class="btn-action-primary" @click="clickCancel()">
              <i class="fa fa-reply"></i> Hủy bỏ
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>

import BaseInput from "@/views/base/BaseInput";
import draggable from 'vuedraggable'
import {ActionEditor, TypeChooseLayer, TypePlayList} from "@/constant";
import SlideShowFormEditor from "@/views/slide_show/SlideShowFormEditor";

export default {
  name: 'SlideShowEditor',
  components: {SlideShowFormEditor, BaseInput, draggable},
  props: {
    items: Array,
    action: {
      type: Number
    },
    itemSelected: Number,
    size: Object,
    title: {
      type: String,
    },
    ratio: {
      type: String,
    },
    previewId: String
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      actionEditor: ActionEditor,
      typeLayer: TypeChooseLayer,
      titleInput: {
        options: {
          placeholder: "Tiêu đề trình diễn",
          label: 'Tiêu đề trình diễn'
        },
        data: {
          name: "title",
          model: '',
          updateCallback: function () {
            that.submitSaveSlideShow();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tiêu đề trình diễn không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        },
      },
      ratioSelect: {
        options: {
          filter: false,
          label: "Ratio <i></i>",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "ratio",
          model: '16:9',
          items: [
            {key: "16:9", value: "16:9 (1080p)"},
            {key: "16:10", value: "16:10"},
            {key: "4:3", value: "4:3"},
            {key: "5:4", value: "5:4"},
            {key: "3:2", value: "3:2"},
            {key: "17:9", value: "17:9"},
            {key: "16:4.5", value: "16:4.5"},
            {key: "16:3", value: "16:3"},
          ],
        }
      },
      itemsLayerChoose: [
        {id: 1, type: TypeChooseLayer.TEXT, title: 'Văn bản', icon: 'fa-file-text'},
        {id: 2, type: TypeChooseLayer.VIDEO, title: 'Video', icon: 'fa-video-camera'},
        {id: 3, type: TypeChooseLayer.IMAGE, title: 'Hình ảnh', icon: 'fa-image'},
        {id: 4, type: TypeChooseLayer.PLAY_LIST, title: 'Danh sách phát', icon: 'fa-list'},
        {id: 5, type: TypeChooseLayer.YOUTUBE, title: 'Youtube', icon: 'fa-youtube'},
        {id: 6, type: TypeChooseLayer.RSS, title: 'RSS', icon: 'fa-rss'},
        {id: 7, type: TypeChooseLayer.DOCUMENT, title: 'Tài liệu', icon: 'fa-file-text'},
        {id: 8, type: TypeChooseLayer.STREAM_VTV, title: 'Kênh trực tuyến', icon: 'fa-television'},
      ],
      isValidSubmit: false,
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getTitleHeader() {
      if (this.action === this.actionEditor.LAYOUT_SETTING) {
        return 'Cài đặt giao diện';
      } else if (this.action === this.actionEditor.ADD_LAYER) {
        return 'Thêm giao diện';
      } else if (this.action === this.actionEditor.EDITOR_LAYER) {
        var itemSelected = this.items[this.itemSelected];
        switch (itemSelected.extractData.typeLayer) {
          case this.typeLayer.TEXT : {
            return 'Cấu hình chữ';
          }
          case this.typeLayer.IMAGE : {
            return 'Cấu hình hình ảnh';
          }
          case this.typeLayer.VIDEO : {
            return 'Cấu hình Video';
          }
          case this.typeLayer.PLAY_LIST : {
            return 'Cấu hình PlayList';
          }
          case this.typeLayer.YOUTUBE : {
            return 'Cấu hình YouTube';
          }
          case this.typeLayer.RSS : {
            return 'Cấu hình RSS';
          }
          case this.typeLayer.DOCUMENT : {
            return 'Cấu hình Tài liệu';
          }
          case this.typeLayer.AREA_TEXT : {
            return 'Cấu hình Vùng văn bản';
          }
          case this.typeLayer.AREA_LEFT : {
            return 'Cấu hình Vùng trái';
          }
          case this.typeLayer.AREA_RIGHT : {
            return 'Cấu hình Vùng phải';
          }
          case this.typeLayer.FULL_SCREEN : {
            return 'Cấu hình Toàn màn hình';
          }
          case this.typeLayer.STREAM_VTV : {
            return 'Cấu hình Kênh trực tuyến';
          }
        }
      }
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getTitleLayer(item) {
      switch (item.extractData.typeLayer) {
        case this.typeLayer.TEXT : {
          return `Text: ${item.extractData.title}`;
        }
        case this.typeLayer.IMAGE : {
          return `Image: ${item.extractData.title}`;
        }
        case this.typeLayer.VIDEO : {
          return `Video: ${item.extractData.title}`;
        }
        case this.typeLayer.STREAM_VTV : {
          return `Live: ${item.extractData.title}`;
        }
        case this.typeLayer.PLAY_LIST : {
          return `PlayList: ${item.extractData.name}`;
        }
        case this.typeLayer.YOUTUBE : {
          return `YouTube Video`;
        }
        case this.typeLayer.RSS : {
          return `RSS : ${item.extractData.title}`;
        }
        case this.typeLayer.DOCUMENT : {
          return `Tài liệu : ${item.extractData.title}`;
        }
        case this.typeLayer.AREA_TEXT : {
          return `Vùng văn bản : ${item.extractData.title}`;
        }
        case this.typeLayer.AREA_LEFT : {
          return `Vùng trái : ${item.extractData.title}`;
        }
        case this.typeLayer.AREA_RIGHT : {
          return `Vùng phải : ${item.extractData.title}`;
        }
        case this.typeLayer.FULL_SCREEN : {
          return `Toàn màn hình : ${item.extractData.title}`;
        }
      }
    },
    checkMoveLayer(e) {
      this.$emit("change:layer", e);
    },
    activeLayer(id) {
      this.$emit("active:layer", id);
    },
    removeLayer(id) {
      this.$emit("remove:layer", id);
    },
    chooseLayer(element) {
      var exitsYoutube = false;
      if (element.type === this.typeLayer.VIDEO || element.type === this.typeLayer.YOUTUBE || element.type === this.typeLayer.STREAM_VTV) {
        for (var i = 0; i < this.items.length; i++) {
          var data = this.items[i].extractData;
          if (data.typeLayer === this.typeLayer.YOUTUBE || data.typeLayer === this.typeLayer.STREAM_VTV || data.typeLayer === this.typeLayer.VIDEO
              || (data.typeLayer === this.typeLayer.PLAY_LIST && data.type === TypePlayList.VIDEO)) {
            exitsYoutube = true;
            break;
          }
        }
      }
      if (exitsYoutube) {
        this.showWarningMsg({message: 'Bạn không thể có nhiều hơn một video trong một trình diễn!'})
      } else {
        this.$emit("choose:layer", element);
      }
    },
    validateItems() {
      if (this.items && this.items.length === 0) {
        this.isValidSubmit = true;
      } else {
        this.isValidSubmit = false;
      }
    },
    submitSaveSlideShow() {
      this.validateItems();
      if (!this.titleInput.data.validator.valid() || this.isValidSubmit) {
        this.showErrorMsg({message: 'Vui lòng kiểm tra tiêu đề và bố cục giao diện'});
        return;
      }
      let that = this;
      this.$emit("loading", true);
      var items = [];
      this.items.map(each => {
        var item = Object.assign({}, each);
        delete item.extractData;
        var _extractData = each.extractData;
        item.active = false;
        item.extractData = {
          id: _extractData.id ? _extractData.id : null,
          typeLayer: _extractData.typeLayer,
          videoId: _extractData.videoId ? _extractData.videoId : null,
          sourceIds: _extractData.sourceIds ? _extractData.sourceIds : null
        }
        items.push(item);
      })
      var _urlAPI = '/slide_show/add';
      var objDataRequest = {
        title: that.titleInput.data.model,
        widthDesign: that.size.width,
        heightDesign: that.size.height,
        ratio: that.ratioSelect.data.model,
        idPreview: that.previewId,
        draggableModels: items
      };
      if (this.$route.params.id) {
        objDataRequest.id = this.$route.params.id;
        _urlAPI = '/slide_show/update';
      }
      this.$helper.loadDataSource({
        url: _urlAPI,
        dataSubmit: function () {
          return objDataRequest;
        },
        ignoreDefaultData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.$emit("loading", false);
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            if (that.$route.params.id) {
              that.showSuccessMsg({message: "Cập nhật trình diễn thành công"});
            } else {
              that.showSuccessMsg({message: "Thêm mới trình diễn thành công"});
            }
            that.$router.push("/files-screen-management/slide-show.html");
          }
        },
        errorCallback: function (error) {
          that.$emit("loading", true);
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    clickCancel() {
      let that = this;
      if (that.previewId) {
        this.$helper.loadDataSource({
          url: '/slide_show_preview/delete',
          dataSubmit: function () {
            return {
              id: that.previewId
            };
          },
          ignoreDefaultData: true,
          isJsonContentType: false,
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      }
      that.$router.go(-1);
    }
  },
  watch: {
    title(value) {
      this.titleInput.data.model = value;
    },
    ratio(value) {
      this.ratioSelect.data.model = value;
    },
  },
  destroyed() {
  }
}
</script>

<style scoped>
video {
  object-fit: contain;
}

.group-layer-setting .title {
  border-radius: unset !important;
  position: unset !important;
  background: white !important;
  border-bottom: unset !important;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  padding-left: 13px;
}

.group-layer-setting .layers-wrapper ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.group-layer-setting .layers-wrapper ul > li {
  margin-bottom: 4px;
  background: #E8E9EC !important;
  border-radius: 4px;
  color: #4B4B50 !important;
  padding: 10px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.group-layer-setting .no-layers-content-message {
  font-style: italic;
  font-size: 12px;
}

.layout-insert-item-column {
  padding: 0;
  padding-right: 12px;
  text-align: center;
}

.layout-insert-item-type {
  border-radius: 3px;
  width: 100%;
  height: 80px;
  background: #dcdcdc;
  color: #fff;
  cursor: pointer;
  transition: all ease-in-out .5s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.layout-insert-item-type:hover {
  background: rgba(157, 151, 151, 0.49);
}

.layout-insert-item-type i {
  font-size: 30px;
}

.layout-insert-item-label {
  text-align: center;
  line-height: 42px;
  font-size: 12px;
}

.text-right {
  cursor: pointer;
  border: 1px solid #00000040;
  padding: -4px;
  border-radius: 5px;
  width: 23px;
  height: 23px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.text-right:hover {
  background: rgba(128, 128, 128, 0.3);
  color: white;
}
</style>
<style>
#slide-show-editor .group-color-picker {
  position: relative;
}

#slide-show-editor .one-colorpicker {
  position: absolute;
  top: 1px;
  right: 1px;
}

#slide-show-editor .color-block {
  width: 28px;
  height: 34px;
}

#slide-show-editor .color-block-layer.value {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
